export default __webpack_public_path__ + "img/ufo.58567441ba20dc65fdfcfecb474b1f53.svg";